import React from "react";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";
import Download from "../../assets/download.svg";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { credit_notes } from "../../actions/shipmentNPayment";
import moment from "moment";
import endpoint from "../../config/endpoint";
import { downloadPDF } from "../../config/helper";
import { toast } from "react-toastify";
import { useState } from "react";
import { useMemo } from "react";

const Transactions = () => {
  const dispatch = useDispatch();
  const columns = [
    {
      header: "Product",
      accessor: "Matnr",
      width: 20,
    },
    {
      header: "Reference No",
      accessor: "Vbeln",
      width: 20,
    },
    {
      header: "Ref Claim No",
      accessor: "Claimno",
      width: 20,
    },
    {
      header: "Order Type",
      accessor: "Vtweg",
      width: 8,
      cell: (row) => (row.Vtweg === "41" ? "FTL" : "FD"),
    },
    {
      header: "Date and Time",
      accessor: "Bstdk",
      width: 20,
      cell: (row) =>
        row.Bstdk === "00000000" || row.Bstdk === ""
          ? ""
          : moment(row.Bstdk, "YYYYMMDD").format("MM/DD/YY"),
    },
    {
      header: "Quantity",
      accessor: "Kwmeng",
      width: 20,
    },
    {
      header: "Download",
      accessor: "amount",
      width: 10,
      cell: (row) => {
        return (
          <div className="w100 flex-center mr1">
            {/* <span>{row.amount}</span> */}
            <span
              className="cursor"
              onClick={() => {
                endpoint
                  .get("/download_credit_memo", {
                    params: {
                      email: localStorage.getItem("email"),
                      credit_memo_id: row.Vbeln,
                    },
                  })
                  .then((res) => {
                    if (res?.data?.pdf_content) {
                      downloadPDF(
                        res?.data?.pdf_content,
                        "Transaction_" + row.Vbeln
                      );
                    } else {
                      toast.error(res?.data?.message);
                    }
                  });
              }}
            >
              <img src={Download} alt="download" width={15} />
            </span>
          </div>
        );
      },
    },
  ];

  const data = useSelector(
    (state) => state?.claims?.txns?.data?.credit_note_list || []
  );
  const [search, setSearch] = useState("");
  // eslint-disable-next-line
  const creditData = useMemo(
    () =>
      search
        ? data?.filter(
            (ele) =>
              ele.Vbeln?.toLowerCase()?.includes(search) ||
              ele.Claimno?.toLowerCase()?.includes(search) ||
              ele.Matnr?.toLowerCase()?.includes(search)
          )
        : data,
    [search, data]
  );

  useEffect(() => {
    dispatch(
      credit_notes({
        email: localStorage.getItem("email"),
        page: 1,
      })
    );
    // eslint-disable-next-line
  }, []);
  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Credit Note"}
          showGrid={false}
          searchPlaceholder={"Search by product, reference no, ref claim no..."}
          // selectBox={false}
          // options={[
          //   { label: "All Transaction", value: "all" },
          //   { label: "Pending Transaction", value: "pending" },
          //   { label: "Completed Transaction", value: "completed" },
          // ]}
          callSearch={(searchText) => {
            setSearch(searchText?.toLowerCase());
          }}
          searchVal={search}
          defaultValue={"all"}
        >
          <Table
            columns={columns}
            data={creditData}
            action={false}
            actionWidth={8}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Transactions;
